import jwtDecode from 'jwt-decode';
import { capitalize } from 'src/utils/capitalize';

/* eslint-disable no-bitwise */
export const JWT_SECRET = 'jwt-secret-key';
export const JWT_EXPIRES_IN = 3600 * 24 * 2;

export const sign = (payload, privateKey, header) => {
  const now = new Date();
  header.expiresIn = new Date(now.getTime() + header.expiresIn);
  const encodedHeader = btoa(JSON.stringify(header));
  const encodedPayload = btoa(JSON.stringify(payload));
  const signature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(
          item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)
        )
      )
      .join('')
  );

  return `${encodedHeader}.${encodedPayload}.${signature}`;
};

export const decode = (token) => {
  return jwtDecode(token);
};

export const verify = (token) => {
  if (!token) {
    return false;
  }
  const decoded = jwtDecode(token);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export const mapTokenToUserDetails = (token) => {
  // decode accessToken and get payload
  const payload = decode(token);

  console.log('TOKEN = ', token);

  // map payload details to application's user details
  const user = {
    id: payload.sub,
    name: payload.name,
    email: payload.email,
    role: payload.resource_access.compair?.roles[0],
    jobtitle: capitalize(payload.resource_access.compair?.roles[0]),
  };

  return user;
};
